import selectLocation from './selectLocation';
import hideLocationSuggestions from './hideLocationSuggestions';
import computeAverageFootprint from './computeAverageFootprint';
import initialize from './initialize';
import reset from './reset';
import updateActionStatus from './updateActionStatus';
import addVehicle from './addVehicle';
import removeVehicle from './removeVehicle';
import updateTradeInVehicle from './updateTradeInVehicle';
import updateVehicleEfficiency from './updateVehicleEfficiency';
import updateVehicleFuelType from './updateVehicleFuelType';
import updateNumericInput from './updateNumericInput';
import setUnitSystem from './setUnitSystem';
import toggleGlobalMenu from './toggleGlobalMenu';
import setMonthlyInput from './setMonthlyInput';
import updateInputLocationDisplay from './updateInputLocationDisplay';
import receiveWidgetMessage from './receiveWidgetMessage';
import setLocale from './setLocale';
import { computeTakeActionResults, computeUserFootprint } from './computeResults';
import patch from './patch';
import * as user from './user';
import * as leaders from './leaders';
import * as profilePhoto from './profilePhoto';
import updateUI from './updateUI';
import * as toast from './toast';
import * as locationAutocomplete from './locationAutocomplete.ts';

const toggleModal = modalName => (dispatch, getState) => {
  dispatch(patch({
    ui: { modal: getState().ui.modal === modalName ? '' : modalName },
  }));
};


export { default as pick } from 'lodash/pick';
export { bindActionCreators } from 'redux';

export default {
  selectLocation,
  hideLocationSuggestions,
  computeAverageFootprint,
  computeUserFootprint,
  initialize,
  reset,
  updateActionStatus,
  computeTakeActionResults,
  addVehicle,
  removeVehicle,
  updateTradeInVehicle,
  updateVehicleEfficiency,
  updateVehicleFuelType,
  updateNumericInput,
  setUnitSystem,
  toggleGlobalMenu,
  setMonthlyInput,
  receiveWidgetMessage,
  updateInputLocationDisplay,
  setLocale,
  updateUI,
  toggleModal,
  patch: payload => (dispatch, _getState) => dispatch(patch(payload)),
  ...user,
  ...leaders,
  ...profilePhoto,
  ...toast,
  ...locationAutocomplete,
};
